import type { Ruta as RutaTyp } from '../types'
import MarkeradText from './MarkeradText'

const RUTA_ETIKETT: Record<RutaTyp['typ'], string> = {
  uppslag: 'Uppslag',
  sakerhet: 'Säkerhet',
  exempel: 'Exempel',
  rakna: 'Räkneexempel',
}

const RUTA_IKON: Record<RutaTyp['typ'], string> = {
  uppslag: '📖',
  sakerhet: '⚠️',
  exempel: '💡',
  rakna: '🧮',
}

/** En uppslagsruta ur avsnittets `rutor[]` — exakta gränsvärden, säkerhets-
 *  information eller ett utarbetat exempel som eleven kan slå upp vid behov.
 *  Renderas sist i avsnittet (se Avsnitt.tsx), som Tabell. `typ` styr färg och
 *  ikon så att en säkerhetsruta syns tydligt annorlunda än ett uppslag.
 *  `innehall` renderas som markdown, inte klartext — förekommande innehåll
 *  bäddar in egna jämförelsetabeller (`| kolumn | ... |`-syntax) mitt i
 *  texten, och MarkeradText (med GFM-tabellstöd) är det enda som visar dem rätt. */
export default function Ruta({ ruta }: { ruta: RutaTyp }) {
  return (
    <aside className={`ruta ruta-${ruta.typ}`}>
      <div className="ruta-huvud">
        <span className="ruta-ikon" aria-hidden="true">
          {RUTA_IKON[ruta.typ]}
        </span>
        <span className="ruta-etikett">{RUTA_ETIKETT[ruta.typ] ?? ruta.typ}</span>
      </div>
      <h4>{ruta.rubrik}</h4>
      <MarkeradText markdown={ruta.innehall} />
    </aside>
  )
}
